var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHitachi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 51",
    width: 300,
    height: 51,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HITACHI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1606.77 2515.03h2693.86v-3508.34h-2693.86z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1606.77 2515.03h2693.86v-3508.34h-2693.86z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ff0200 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10785"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: g10787",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10795",
    className: "s0",
    d: "m240.5 2.1v18.3h24.6v-18.3c0 0 12 0 12.2 0v45.9h-12.2v-20.2h-24.6v20.2h-12.2v-45.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10799",
    className: "s0",
    d: "m125.3 2.1v7.8h-18.5v38.1h-12.2v-38.1h-18.5v-7.8c0 0 49.2 0 49.2 0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g10801"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10803",
    className: "s0",
    d: "m172.4 48h-13.5l-4-9.9h-22.7l-4 9.9h-13.4l21.4-45.8h15zm-28.8-38.1l-8.5 20.8h16.9z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "path10805",
    className: "s0",
    d: "m286.9 48h12.2v-45.8h-12.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10807"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: g10809",
    clipPath: "url(#cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10817",
    className: "s0",
    d: "m13.2 2.1c0 0 0 18.5 0 18.3h24.6v-18.3c0 0 11.9 0 12.1 0v45.9h-12.1v-20.2h-24.6v20.2h-12.2v-45.9z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "path10819",
    className: "s0",
    d: "m59.5 48h12.1v-45.8h-12.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10831",
    className: "s0",
    d: "m172 35.3c-1-3.2-1.6-6.3-1.6-9.9 0-4.8 0.8-9.4 3.1-13.4 2.3-4 6.1-7.2 10.5-8.7 4.2-1.6 8.6-2.5 13.5-2.5 5.4 0 10.5 1.3 15.3 3.2 4.4 1.9 7.6 5.9 8.6 10.5 0.3 0.8 0.5 1.9 0.5 2.9h-12.9c0-1.2-0.2-2.5-0.6-3.5-1-2.6-3.1-4.5-5.7-5.3-1.7-0.6-3.5-0.8-5.2-0.8-2.1 0-4.2 0.4-6.1 1-3.2 1.1-5.5 3.6-6.8 6.7-1 3-1.6 6.3-1.6 9.7 0 2.7 0.4 5.5 1.2 8 1.1 3.8 3.6 6.3 6.8 7.6 2.1 0.8 4.2 1.2 6.5 1.2 1.9 0 3.8-0.2 5.6-0.8 2.4-0.9 4.3-2.5 5.3-4.8 0.6-1.5 1.1-3.2 1.1-4.9h12.8q0 2.2-0.6 4.4c-1.1 4.7-4.3 8.4-8.5 10.1-4.8 2.1-10.1 3.2-15.5 3.2-4.2 0-8.4-0.7-12.4-1.9-6.1-1.9-11.2-6.1-13.3-12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitachi);
export default __webpack_public_path__ + "static/media/HITACHI.044de30b9debf92310d13d45512368f1.svg";
export { ForwardRef as ReactComponent };